module.exports = __webpack_public_path__ + "img/icon_map_hsjssh.c4d71467.png";